document.addEventListener('DOMContentLoaded', async function () {
  const productGrid = document.getElementById('product-grid');

  if (!productGrid) return;

  let nextPage = 2;

  while (true) {
    try {
      const url = `${window.location.pathname}?page=${nextPage}`;
      const response = await fetch(url);

      if (!response.ok) break;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('#product-grid > li');

      if (newProducts.length === 0) break;

      newProducts.forEach(product => {
        productGrid.appendChild(product);
      });

      nextPage++;

    } catch (error) {
      console.error('Error loading products:', error);
      break;
    }
  }
});